// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"629":"fa30c1fd","8428":"4a918a8b"}[chunkId] + ".chunk.css";
};